module.exports = __webpack_public_path__ + "teqbahn-assets/media/GlobalCollaborationAcrossProfessions.c0619e18.png";